import { Invoice } from "src/interfaces/Invoice";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InvoicesState {
  invoices: Invoice[];
  isSubscribed: boolean;
}

const initialState: InvoicesState = {
  invoices: [],
  isSubscribed: false,
};

export const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setInvoices: (state, action: PayloadAction<Invoice[]>) => {
      state.invoices = action.payload;
      state.isSubscribed = true;
    },
  },
});

export const { setInvoices } = invoicesSlice.actions;

export default invoicesSlice.reducer;
